import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'

/**
 * 删除实体命令，支持撤销恢复。
 */
export class DeleteEntityCommand extends Command {
  private entities: IEntity[]
  private viewManager: CADViewManager

  constructor(entities: IEntity[], viewManager: CADViewManager) {
    super()
    this.entities = entities
    this.viewManager = viewManager
  }

  /** 从视图管理器移除实体 */
  execute(): void {
    this.viewManager.deleteEntities(this.entities)
  }

  /** 撤销：重新加入被删除的实体 */
  undo(): void {
    this.viewManager.addEntities(this.entities)
  }
}
